import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3" }
const _hoisted_2 = { class: "text-lg truncate" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "space-y-5" }

import { computed, onMounted, reactive, useTemplateRef } from "vue";
import { useRouter } from "vue-router";
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryMd, ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { AddIcon, ArrowLeftIcon, LinkShareIcon } from "@easy/ui/icons";
import { FormInput } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import { useIsDirty } from "@/shared/utils/forms/useIsDirty";
import { PageSection } from "@/apps/page/page.interfaces";
import { useActions, useState } from "@/store/vuex-composition-mappers";
import { useFormValidation } from "@/shared/utils/forms/useFormValidation";
import { required } from "@/shared/utils/forms/i18n-vuelidators";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import PageColors from "../PageColors.vue";
import { t } from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditTool',
  props: {
    section: {},
    backupData: {}
  },
  emits: ["save", "quit"],
  setup(__props: any) {

const props = __props;
const projectNameRef = useTemplateRef<FormInput>("projectName");



const router = useRouter();
const { page } = useState("page", ["page"]);
const { connectToolSectionWithProject } = useActions("page", ["connectToolSectionWithProject"]);
const { isDirty } = useIsDirty(props.backupData, props.section);

const project = reactive({ name: "" });
const { v$, validateForm } = useFormValidation(
    {
        name: { required },
    },
    project
);

const sectionType = computed(() => props.section.type);
const projectData = computed(() => props.section.projectData || { uuid: "" });
const hasProjectConnected = computed(() => Boolean(props.section.projectId));
const editUrl = computed(
    () => `/${sectionType.value}/projects/${projectData.value.uuid}?page=${page.value.uuid}`
);

const title = computed(() => t(`page.${sectionType.value}.title`));
const editTitle = computed(() => t(`page.${sectionType.value}.edit`));

onMounted(() => {
    if (projectNameRef.value) {
        projectNameRef.value.$el.querySelector("input")?.focus();
    }
});

async function makeNewProject() {
    const isFormCorrect = await validateForm();

    if (!isFormCorrect) {
        return;
    }
    const projectUuid = await connectToolSectionWithProject({
        lang: page.value.lang,
        projectName: project.name,
        tool: sectionType.value,
        sectionId: props.section.id,
    });
    if (projectUuid) {
        await router.push(`/${sectionType.value}/projects/${projectUuid}?page=${page.value.uuid}`);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(PageSidebar), null, {
    sidebarTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ButtonSecondaryIconSm), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('quit')))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1)
      ])
    ]),
    sidebarMain: _withCtx(() => [
      _createVNode(_unref(CardToggle), {
        title: 
                    hasProjectConnected.value
                        ? _ctx.section?.projectData?.name || ''
                        : _ctx.$t('page.block.content')
                
      }, {
        default: _withCtx(() => [
          (hasProjectConnected.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: editUrl.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ButtonSecondaryMd), { class: "w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LinkShareIcon)),
                      _createElementVNode("span", null, _toDisplayString(editTitle.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(FormInput), {
                  ref: "projectName",
                  required: "",
                  title: _ctx.$t('page.sections.new_project_name'),
                  modelValue: project.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((project.name) = $event)),
                  onBlur: _unref(v$).name.$touch,
                  error: _unref(v$).name.$errors?.[0]?.$message
                }, null, 8, ["title", "modelValue", "onBlur", "error"]),
                _createVNode(_unref(ButtonSecondaryMd), {
                  class: "w-full mt-3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (makeNewProject()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AddIcon)),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)("page.sections.create_project", { tool: sectionType.value })), 1)
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(CardToggle), {
        title: _ctx.$t('page.block.styles')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (sectionType.value !== 'love' && sectionType.value !== 'faq')
              ? (_openBlock(), _createBlock(PageColors, {
                  key: 0,
                  title: _ctx.$t('shared.colors.brand'),
                  modelValue: _ctx.section.styleValues.brand,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.section.styleValues.brand) = $event))
                }, null, 8, ["title", "modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(PageColors, {
              title: _ctx.$t('shared.colors.background'),
              modelValue: _ctx.section.styleValues.background,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.section.styleValues.background) = $event))
            }, null, 8, ["title", "modelValue"]),
            _createVNode(PageColors, {
              title: _ctx.$t('shared.colors.text'),
              modelValue: _ctx.section.styleValues.text,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.section.styleValues.text) = $event))
            }, null, 8, ["title", "modelValue"]),
            _createVNode(PageColors, {
              title: _ctx.$t('shared.colors.card_background'),
              modelValue: _ctx.section.styleValues.cardBackground,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.section.styleValues.cardBackground) = $event))
            }, null, 8, ["title", "modelValue"]),
            _createVNode(PageColors, {
              title: _ctx.$t('shared.colors.card_text'),
              modelValue: _ctx.section.styleValues.cardText,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.section.styleValues.cardText) = $event))
            }, null, 8, ["title", "modelValue"]),
            _createVNode(PageColors, {
              title: _ctx.$t('shared.colors.border'),
              modelValue: _ctx.section.styleValues.border,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.section.styleValues.border) = $event))
            }, null, 8, ["title", "modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    sidebarFooter: _withCtx(() => [
      _createVNode(cSaveButton, {
        onSave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('save'))),
        disabled: !_unref(isDirty),
        ctaDisabled: _ctx.$t('shared.save')
      }, null, 8, ["disabled", "ctaDisabled"])
    ]),
    _: 1
  }))
}
}

})